/** Сколько раз автоматически перезапрашиваем картинку после сетевой ошибки, прежде чем показать кнопку «Повторить» */
export const IMAGE_MAX_AUTO_RETRIES = 2;
export const IMAGE_RETRY_DELAYS_MS = [500, 1500];

/** Добавляет параметр, чтобы браузер не переиспользовал оборвавшийся запрос */
export const withRetryParam = (url: string, attempt: number) =>
  attempt === 0 ? url : `${url}${url.includes('?') ? '&' : '?'}_r=${attempt}`;
